import queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { Container, Grid, Header, Loader, Message, Dimmer, Image } from "semantic-ui-react";
import {
  checkPasswordResetToken,
  finishPasswordReset
} from "../actions/users/confirmPasswordReset";
import logo from "../assets/images/urbansim/logo.png";
import ConfirmPasswordResetForm from "../components/users/ConfirmPasswordReset";
import { amRoutes } from "../config/config";
import { delayBeforeRedirect } from "../config/constants";
import { history } from "../store";
import { hideFailureMessage, showFailureMessage } from "../store/statusMessages";
import { doesNotExist } from "../utils/utils";

/**
 * Confirm password reset view.
 * Integrates redux action and states.
 */
class ConfirmPasswordResetView extends React.Component {
  /**
   * Checks if password reset token exists and is valid.
   * @param {Object} props      - React props.
   */
  constructor(props) {
    super(props);
    const passwordResetToken = queryString.parse(this.props.location.search).password_reset_token;
    if (doesNotExist(passwordResetToken)) {
      this.props.showFailureMessageAction(
        "Password reset token validation failed",
        "No password reset token provided. Redirecting..."
      );
      setTimeout(() => {
        this.props.hideFailureMessageAction();
        localStorage.clear();
        history.push(amRoutes.dashboard);
      }, delayBeforeRedirect);
    } else {
      this.props.checkPasswordResetTokenAction(passwordResetToken);
    }
  }

  state = { dismissedError: false };

  onDismiss = () => this.setState({ dismissedError: true });

  render() {
    return (
      <Container>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100vh"
          }}
        >
          <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 500 }}>
              <Image size="small" src={logo} style={{ margin: "auto", display: "inline-block" }} />
              <Header as="h1" textAlign="center">
                Reset your UrbanSim password
              </Header>
              <Header as="h3" textAlign="center">
                Enter and confirm new password
              </Header>
              <Dimmer
                page
                active={
                  this.props.showFailureMessage ||
                  this.props.showSuccessMessage ||
                  this.props.sendingRequest
                }
              >
                {!this.props.showSuccessMessage && !this.props.showFailureMessage && <Loader />}
                {this.props.showSuccessMessage && (
                  <Message
                    positive
                    header={this.props.submitSucceededMessageHeader}
                    content={this.props.submitSucceededMessageContent}
                  />
                )}
                {this.props.showFailureMessage && !this.state.dismissedError && (
                  <Message negative onDismiss={this.onDismiss}>
                    <Message.Header>{this.props.submitFailedMessageHeader}</Message.Header>
                    <Message.Content>{this.props.submitFailedMessageContent}</Message.Content>
                  </Message>
                )}
              </Dimmer>
              <ConfirmPasswordResetForm
                onSubmit={values =>
                  this.props.finishPasswordReset(this.props.passwordResetToken, values.password)
                }
                formSubmitFailed={this.props.confirmPasswordResetFailed}
                formSubmitFailedMessage={this.props.confirmPasswordResetFailedMessage}
                isLoading={this.props.sendingRequest}
              />
              {this.props.formSubmitFailed ? (
                <Message negative>{this.props.formSubmitFailedMessage}</Message>
              ) : (
                <div />
              )}
            </Grid.Column>
          </Grid>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  showSuccessMessage: state.statusMessages.showSuccessMessage,
  submitSucceededMessageHeader: state.statusMessages.submitSucceededMessageHeader,
  submitSucceededMessageContent: state.statusMessages.submitSucceededMessageContent,
  showFailureMessage: state.statusMessages.showFailureMessage,
  submitFailedMessageHeader: state.statusMessages.submitFailedMessageHeader,
  submitFailedMessageContent: state.statusMessages.submitFailedMessageContent,
  isLoading: state.statusMessages.isLoading,
  sendingRequest: state.confirmPasswordReset.sendingRequest,
  passwordResetToken: state.confirmPasswordReset.passwordResetToken,
  confirmPasswordResetFailed: state.confirmPasswordReset.confirmPasswordResetFailed,
  confirmPasswordResetFailedMessage: state.confirmPasswordReset.confirmPasswordResetFailedMessage
});

const mapDispatchToProps = dispatch => ({
  showFailureMessageAction: (header, message) => dispatch(showFailureMessage(header, message)),
  hideFailureMessageAction: () => dispatch(hideFailureMessage()),
  checkPasswordResetTokenAction: token => dispatch(checkPasswordResetToken(token)),
  finishPasswordReset: (token, password) => dispatch(finishPasswordReset(token, password))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPasswordResetView);
